import {
    mdiBank,
    mdiCreditCardCheckOutline,
    mdiWalletBifoldOutline,
} from '@mdi/js'
import {Card} from 'swayok-react-mdb-ui-kit/components/Card/Card'
import {CardBody} from 'swayok-react-mdb-ui-kit/components/Card/CardBody'
import {Icon} from 'swayok-react-mdb-ui-kit/components/Icon/Icon'
import {UserAvatar} from '../../../../components/UserAvatar'
import {trans} from '../../../../helpers'
import {useUserData} from '../../../../hooks'
import {useFullUserName} from '../../../../hooks/useFullUserName'

// Информация о профиле пользователя в ЛК в разделе "Финансы".
export function CabinetFinancesSideMenuUserInfo() {

    const user = useUserData()!

    if (!user) {
        return null
    }

    const userName = useFullUserName(true)
    const rating: number = 70 // Todo: обновить когда будет реализовано в CRM.

    return (
        <Card id="cabinet-side-menu-user-info">
            <CardBody>
                <div className="d-flex gap-4 flex-row align-items-center">
                    <UserAvatar userName={userName} />
                    <div className="d-flex flex-column align-items-stretch">
                        <div className="fw-500">
                            {userName}
                        </div>
                        <div
                            className="flex-container-row gap-2"
                            title={String(user.rating)}
                        >
                            <div className="me-2">
                                <span className="text-muted">
                                    {trans().cabinet.side_navigation.client_rating}:
                                </span>
                                <span className="fw-500 ms-1">{rating}%</span>
                            </div>
                        </div>
                    </div>
                </div>
                {user.details.bank && (
                    <div className="mt-3">
                        <div className="with-icon-flex">
                            <Icon
                                path={mdiBank}
                                color="muted"
                                className="me-2"
                            />
                            {user.details.bank.name}
                        </div>
                        <div className="with-icon-flex mt-2">
                            <Icon
                                path={mdiWalletBifoldOutline}
                                color="muted"
                                className="me-2"
                            />
                            {user.details.bank.account}
                        </div>
                        {user.details.bank.cardNumber && (
                            <div className="with-icon-flex mt-2">
                                <Icon
                                    path={mdiCreditCardCheckOutline}
                                    color="muted"
                                    className="me-2"
                                />
                                {user.details.bank?.cardNumber}
                            </div>
                        )}
                    </div>
                )}
            </CardBody>
        </Card>
    )
}
